export const settings = {
  title: "Settings",
  subtitle: "Customize your experience with Araria",
  sections: {
    site: {
      title: "Site Settings",
      subtitle: "Customize the appearance and behavior of Araria",
    },
    api: {
      title: "API Settings",
      subtitle: "Manage your API keys and integrations",
      araria: {
        title: "Araria API Key",
        description: "Your unique key to access Araria services",
        generate: "Generate Key",
        regenerate: "Regenerate Key",
        copy: "Copy Key",
        allowedDomains: "Allowed Domains",
        allowedDomainsPlaceholder: "Enter allowed domains (comma separated)",
      },
      providers: {
        title: "AI Providers",
        description: "Configure your API keys for different AI providers",
        openai: "OpenAI API Key",
        anthropic: "Anthropic API Key",
        google: "Google AI API Key",
        placeholder: "Enter your API key",
        save: "Save",
        saved: "Key Saved",
        delete: "Remove Key",
        notice:
          "API keys are stored locally in your device and are not shared with our team or third parties.",
      },
    },
    plan: {
      title: "Subscription Plan",
      subtitle: "Manage your current subscription",
      current: "Current Plan",
      upgrade: "Upgrade Plan",
      downgrade: "Downgrade Plan",
      change: "Change Plan",
    },
  },
  theme: "Theme",
  language: "Language",
  darkMode: "Dark Mode",
  lightMode: "Light Mode",
  english: "English",
  portuguese: "Português",
  spanish: "Español",
};
